import './logRocket';
import LogRocket from 'logrocket';
import logo from './logo.svg';
import './App.css';
import React from 'react';
import { ReactFlowWrapper } from './components';
import { PolicyComponents } from './xmlParsing/interfaces';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
// import { appInsights, reactPlugin } from './appInsights';
import { ErrorReturn } from './utils/ErrorReturn';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'clsx';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navbar from './components/uiComponents/Navbar';
import Debugger from './components/Debugger/Debugger';
import JsonEditorComponent from './components/jsonEditor/jsonEditor';
import { JsonEditorPrototype } from './components/jsonEditor/jsonEditorPrototype';
import { ErrorBoundary, useErrorHandler } from 'react-error-boundary';
import { FallbackComponent } from './fallback';
import { getSessionId, getJsonEditor, submitJSONError, setErrorJSON } from './store';
import TOSUIComponent from './termsOfService';

function App() {
  const sessionId = useSelector(getSessionId);
  const [userId, setUserId] = useState<string>(localStorage.getItem('userId') || '');
  const [email, setEmail] = useState<string>(localStorage.getItem('userEmailId') || '');
  const [showTOS, setShowTOS] = useState<boolean>(!localStorage.getItem('userId'));

  const handleError = useErrorHandler();
  const dispatch = useDispatch();
  const editorState = useSelector(getJsonEditor);
  const generateId = () => 'user' + Math.floor(Math.random() * 10000) + '-' + Date.now();

  useEffect(() => {
    let _userId: any;
    if (!localStorage.getItem('userId')) {
      _userId = generateId();
      localStorage.setItem('userId', _userId);
    } else {
      _userId = localStorage.getItem('userId');
    }
    LogRocket.identify(_userId, {});
    setUserId(_userId);
  }, []);

  const errorHandler = (error: any, errorInfo: any) => {
    let errorJson = JSON.stringify({ error: error, errorInfo: errorInfo, policyJson: editorState });
    dispatch(setErrorJSON(errorJson));
    dispatch(submitJSONError({ sessionId, errorJson }));
  };
  try {
    return (
      <>
        <Router>
          <ErrorBoundary FallbackComponent={FallbackComponent} onError={errorHandler}>
            <>
              <Navbar />
              <Routes>
                <Route
                  path="/xmlEditor"
                  element={
                    <div id="uiWrapper">
                      <ReactFlowWrapper />
                    </div>
                  }
                />
                <Route
                  path="/Debugger"
                  element={
                    <div id="uiWrapper">
                      <Debugger />
                    </div>
                  }
                />
                <Route
                  path="/SimpleEditor"
                  element={
                    <div id="uiWrapper">
                      <JsonEditorPrototype />
                    </div>
                  }
                />
                <Route
                  path="/"
                  element={
                    <div id="uiWrapper">
                      <JsonEditorComponent />
                    </div>
                  }
                />
              </Routes>
            </>
          </ErrorBoundary>
        </Router>
      </>
    );
  } catch (e) {
    handleError(e);
    return <>Error</>;
  }
}

// export default withAITracking(reactPlugin, App);
export default App;
